<template>
    <div style="background-color: #181a1b; color: white; padding: 20px; margin-top: 10px; border-radius: 10px;">
        <div style="float: left;">
            <button class="btn btn-link text-white" @click="handleBackButtonPress">
                <i class="fas fa-arrow-left"></i>
            </button>
        </div>
        <div style="margin-bottom:20px;">
            <h3><i class="fa-solid fa-user"></i> {{ this.$props.candidateSelected["firstname"] }} {{ this.$props.candidateSelected["lastname"] }}</h3>
        </div>
        <table class="dark-table">
                <tbody>
                    <td><i class="fa-solid fa-clipboard"></i> {{ this.$props.assessmentSelected.assessmentDetails.totalQuestions }} Questions</td>
                    <td><i class="fa-solid fa-pencil"></i> Score: {{ (this.$props.assessmentSelected.assessmentDetails.correct/this.$props.assessmentSelected.assessmentDetails.totalQuestions) * 100 }}%</td>
                    <td><i class="fa-solid fa-check"></i> Status: {{ this.$props.assessmentSelected.assessmentDetails.status }} </td>
                    <td><i class="fa-solid fa-stopwatch"></i> Duration: {{ this.$props.assessmentSelected.assessmentDetails.durationFormatted }}</td>
                    <td><i class="fa-solid fa-calendar-days"></i> Date Taken: {{ this.$props.assessmentSelected.assessmentDateFormatted }}</td>
                </tbody>
        </table>
        <div class="d-flex">
            <div class="col p-3 w-3">
                <canvas class="chartCanvas" ref="chartCanvas" style="width: 50%; height: 50%;"></canvas>
            </div>
            <div v-if="categories" class="col p-3">
                <table class="dark-table">
                    <tbody>
                        <th>Category</th>
                        <th>Count</th>
                        <tr v-for="(item, index) in this.categories" :key="index">
                            <td>{{ item }}</td>
                            <td>{{ this.dataCounts[index] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="this.$props.assessmentSelected">
            <table class="dark-table">
                    <tbody>
                        <th>Question Code</th>
                        <th>Question</th>
                        <th>Category</th>
                        <th>Selected Answer</th>
                        <tr v-for="(result, index) in this.$props.assessmentSelected.assessmentDetails.results" 
                        class="clickable-row"
                        >
                            <td>{{ result.questionCode }}</td>
                            <td style="text-align: left;">{{ result.assessmentQuestion.question }}</td>
                            <td style="text-align: left;">{{ result.assessmentQuestion.category }}</td>
                            <td :style="{ backgroundColor: matchValues(result) ? '#7ab05a' : '' }">{{ result.selectedAnswer }}</td>
                        </tr>
                    </tbody>
                </table>
        </div>
    </div>
</template>
<script>
import { endpoint } from '@/utils/endpoint/endpointUtils';
import { getCookie, deleteAllCookies } from '@/utils/cookies/cookieUtils';
import { getRandomHexColor } from '@/services/ColorsService';
import { Chart, registerables } from 'chart.js';

export default {
    props: ['assessmentSelected', 'candidateSelected'],
    data() {
        return {
            chartInstance: null,
            currentSelectedIndex: null,
            dataCounts: [],
            categories: [],
            rndColors: []
        }
    },
    mounted() {
        for (const key in this.$props.assessmentSelected.categoryCount) {
            if (this.$props.assessmentSelected.categoryCount.hasOwnProperty(key)) {
                const value = this.$props.assessmentSelected.categoryCount[key];
                this.categories.push(key);
                this.dataCounts.push(value);
                this.rndColors.push(getRandomHexColor());
            }
        }
        this.drawCategoryPieChart();
        this.$forceUpdate();

    },
    methods: {
        matchValues(result) {
            return (result.selectedAnswer === result.correctAnswer);
        },
        handleBackButtonPress() {
            this.$emit('back-button-pressed');
        },
        drawCategoryPieChart() {
            if (this.chartInstance !== null) {
                this.chartInstance.destroy();
            }

            const ctx = this.$refs.chartCanvas.getContext('2d');

            const data = {
                labels : this.categories,
                datasets: [{
                    label: 'Question Categories',
                    data: this.dataCounts,
                    borderWidth: 1,
                    backgroundColor: this.rndColors
                }]
            };

            const config = {
                type: 'doughnut',
                data: data,
                options: {
                        plugins: {
                            legend: {

                            }
                        }
                    }
            };
            // Create a new chart instance
            this.chartInstance = new Chart(ctx, config);
        }
    }
}
</script>
<style scoped>
.dark-table {
    background-color: #292929; /* Dark gray background */
    color: #fff; /* White text color */
    border-collapse: collapse; /* Remove default cell spacing */
    width: 100%;
}

.dark-table th,
.dark-table td {
    padding: 10px; /* Add padding to cells */
    border: 1px solid #383838; /* Dark border for cells */
}

.dark-table th {
    background-color: #3f3f3f; /* Darker gray for table header */
}

.dark-table tbody tr:nth-child(even) {
    background-color: #333; /* Darker background for even rows */
}

.dark-table tbody tr:hover {
    background-color: #4f4f4f; /* Darker background for hover effect */
}

/* Hint of purple */
.dark-table th,
.dark-table td {
    border: 1px solid #383838; /* Dark border for cells */
}

.dark-table th {
    background-color: #27202c; /* Purple background for table header */
}

.dark-table tbody tr:nth-child(even) {
    background-color: #363438; /* Purple background for even rows */
}

.dark-table tbody tr:hover {
    background-color: #2b1542; /* Darker purple background for hover effect */
}

.chartCanvas {
    width: 100%;
    height: auto;
}
</style>